<template>
  <div class="container fluid">
    <div class="pa-1">
      <v-layout wrap>
        <v-flex xs12 class="pb-3 text-xs-right">
          <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
          <v-btn @click="showsearch = true" class="primary"
            ><v-icon>search</v-icon> Advanced Search</v-btn
          >
        </v-flex>
        <v-flex xs6>
          <div style="font-size: 16px; font-weight: 600" class="mb-3 primary--text">
            {{ $t('Timing of purchase') }}
          </div>
        </v-flex>
      </v-layout>

      <template>
        <v-data-table
          :headers="headers"
          :items="data"
          :pagination.sync="pagination"
          item-key="name"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.member_type }}</td>
              <td>
                {{
                  props.item.previous_purchase_date
                    ? moment(props.item.previous_purchase_date).format('DD/MM/YYYY')
                    : '-'
                }}
              </td>
              <td>
                {{
                  props.item.current_purchase_date
                    ? moment(props.item.current_purchase_date).format('DD/MM/YYYY')
                    : '-'
                }}
              </td>
              <td class="text-center">{{ props.item.num_of_date }}</td>
              <td class="text-center">{{ props.item.avg_num_of_date }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>

      <!-- Modal Search -->
      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('Name') }}</label>
                  <input v-model="filter.name" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('Member Type') }}</label>
                  <Multiselect
                    @input="$emit('change', $event)"
                    placeholder="Status"
                    v-model="filter.member_type"
                    :options="memberTypeData"
                    label="text"
                  ></Multiselect>
                </v-flex>
                <v-flex xs12>
                  <label>{{ $t('วันที่ซื้อสินค้าครั้งก่อน') }}</label>
                  <datepicker
                    class="form-control"
                    v-model="filter.previous_purchase_date"
                    name="PreviousPurchasedDate"
                    placeholder="DD/MM/YYYY"
                  ></datepicker>
                </v-flex>
                <v-flex xs12>
                  <label>{{ $t('วันที่ซื้อสินค้าปัจจุบัน') }}</label>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div class="form-control" style="position: relative">
                        <label>จาก</label>
                        <datepicker
                          class="form-control"
                          v-model="filter.current_purchase_date.start"
                          name="PreviousPurchasedDate"
                          placeholder="DD/MM/YYYY"
                        ></datepicker>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" style="position: relative">
                        <label>ถึง</label>
                        <datepicker
                          class="form-control"
                          v-model="filter.current_purchase_date.end"
                          name="PreviousPurchasedDate"
                          placeholder="DD/MM/YYYY"
                        ></datepicker>
                      </div>
                    </v-flex>
                  </v-layout>
                  <!-- <datepicker class="form-control"
                  v-model="filter.current_purchase_date"
                  name="CurrentPurchaseDate"
                  placeholder="DD/MM/YYYY"
                ></datepicker> -->
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ระยะวันที่ห่าง') }}</label>
                  <input v-model="filter.num_of_date" class="form-control" type="text" />
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
              <v-btn @click="onsearch" color="primary">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import exportxlsx from '@/components/elements/exportxlsx.vue'

export default {
  props: ['selectedDate'],
  components: {
    Multiselect,
    datepicker,
    exportxlsx
  },
  data: function () {
    return {
      loading: false,
      // pagination: { rowsPerPage: -1, sortBy: '' },
      pagination: {
        rowsPerPage: 10
      },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      data: [],
      headers: [
        { text: 'Customer', value: 'customer', sortable: false },
        { text: 'Current Status', value: 'member_type', sortable: false },
        { text: 'วันที่ซื้อสินค้าครั้งก่อน', value: 'previous_purchase_date', sortable: false },
        { text: 'วันที่ซื้อสินค้าปัจจุบัน', value: 'current_purchase_date', sortable: false },
        { text: 'ระยะวันที่ห่าง', value: 'num_of_date', sortable: false },
        { text: 'เฉลี่ยระยะวันที่ห่าง', value: 'avg_num_of_date', sortable: false }
      ],
      filter: {
        name: '',
        current_purchase_date: {
          start: '',
          end: ''
        },
        previous_purchase_date: '',
        num_of_date: '',
        avg_num_of_date: '',
        member_type: ''
      },
      showsearch: false,
      memberTypeData: [{ text: 'new' }, { text: 'silver' }, { text: 'gold' }]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    moment() {
      return moment
    },
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted: function () {
    this.getTimingofPurchase()
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.limit = this.pagetotal
        var data = await this.getTimingofPurchase()

        resolve(
          data.map((el) => {
            return {
              Customer: el.name,
              'Current Status': el.member_type,
              วันที่ซื้อสินค้าครั้งก่อน: el.previous_purchase_date
                ? moment(el.previous_purchase_date).format('DD/MM/YYYY')
                : '-',
              วันที่ซื้อสินค้าปัจจุบัน: el.current_purchase_date
                ? moment(el.current_purchase_date).format('DD/MM/YYYY')
                : '-',
              ระยะวันที่ห่าง: el.num_of_date,
              เฉลี่ยระยะวันที่ห่าง: el.avg_num_of_date
            }
          })
        )

        this.limit = 10

        // this.clearSearch();
      })
    },
    getTimingofPurchase() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid // required
        }

        if (vm.filter.name) {
          Object.assign(data, { name: vm.filter.name })
        }
        if (vm.filter.current_purchase_date.start) {
          Object.assign(data, {
            start_date: moment(vm.filter.current_purchase_date.start).format('YYYY-MM-DD')
          })
        }
        if (vm.filter.current_purchase_date.end) {
          Object.assign(data, {
            end_date: moment(vm.filter.current_purchase_date.end).format('YYYY-MM-DD')
          })
        }
        if (vm.filter.previous_purchase_date) {
          Object.assign(data, {
            previous_purchase_date: moment(vm.filter.previous_purchase_date).format('YYYY-MM-DD')
          })
        }
        if (vm.filter.num_of_date) {
          Object.assign(data, { num_of_date: vm.filter.num_of_date })
        }
        if (vm.filter.avg_num_of_date) {
          Object.assign(data, { avg_num_of_date: vm.filter.avg_num_of_date })
        }
        if (vm.filter.member_type) {
          Object.assign(data, { member_type: vm.filter.member_type.text })
        }

        vm.loading = true
        api.getLamySaleReportTimingofPurchase(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.data = response.data
            vm.total = response.total
            vm.loading = false

            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getTimingofPurchase()
      }
    },
    onsearch() {
      this.offset = 0
      this.pageNumber = 1
      this.getTimingofPurchase()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        current_purchase_date: {
          start: '',
          end: ''
        },
        previous_purchase_date: '',
        num_of_date: '',
        avg_num_of_date: ''
      }
      this.onsearch()
    },
    getDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {},
      deep: true
    }
    // filter: function() {

    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/TimingOfPurchase.vue